import * as Sentry from '@sentry/react';
import { Result } from 'antd';
import { type FallbackProps, ErrorBoundary } from 'react-error-boundary';
import { RouterProvider } from 'react-router-dom';

import { MutationToaster } from '@/components/feedback/toast';
import { AnalyticsProvider } from '@/providers/analytics-provider';
import { AntdConfigProvider } from '@/providers/antd-config-provider';
import { AuthProvider } from '@/providers/auth-provider';
import { IconProvider } from '@/providers/icon-provider';
import { QueryProvider } from '@/providers/query-provider';
import { router } from '@/routes';

function Fallback({ error }: FallbackProps) {
  const message = error instanceof Error ? error.message : String(error);
  return <Result status="error" title="Something went wrong" subTitle={message} />;
}

export default function App() {
  return (
    <ErrorBoundary
      FallbackComponent={Fallback}
      onError={(error, info) => {
        Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
      }}
    >
      <QueryProvider>
        <AntdConfigProvider>
          {/* Every mutation's outcome is toasted from here — see <MutationToaster>. */}
          <MutationToaster />
          <IconProvider>
            <AuthProvider>
              <AnalyticsProvider>
                <RouterProvider router={router} />
              </AnalyticsProvider>
            </AuthProvider>
          </IconProvider>
        </AntdConfigProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}
